.meta-data-list {
  margin: 0;
}

.meta-data-list__item {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding: 0.5rem 0;
}

.meta-data-list__item:not(:last-of-type) {
  border-bottom: 1px solid var(--color-grey-400);
}

.meta-data-list__term {
  color: var(--color-grey-700);
}

.meta-data-list__description {
  align-items: center;
  display: inline-flex;
  font-weight: var(--semibold);
  margin: 0;
  text-align: right;
}
